import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig"; // Import Firestore config
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import edit from "../assets/edit.svg";

export default function JobEditPage() {
  const { jobId } = useParams();
  const [job, setJob] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const jobRef = doc(db, "jobs", jobId);
        const jobDoc = await getDoc(jobRef);
        if (jobDoc.exists()) {
          setJob({
            id: jobDoc.id,
            ...jobDoc.data(),
            qualifications: Array.isArray(jobDoc.data().qualifications)
              ? jobDoc.data().qualifications
              : jobDoc.data().qualifications?.split(",") || [],
          });
        } else {
          console.error("No such document!");
        }
      } catch (error) {
        console.error("Error fetching job: ", error);
      }
    };

    if (jobId) {
      fetchJob();
    }
  }, [jobId]);

  const handleUpdateJob = async (updatedJobData) => {
    try {
      const jobRef = doc(db, "jobs", jobId);
      await updateDoc(jobRef, updatedJobData); // Update job in Firestore
      navigate("/dashboard/recruiter"); // Redirect back to dashboard after updating
    } catch (error) {
      console.error("Error updating job: ", error);
    }
  };

  if (!job) return <div>Loading...</div>;

  return (
    <div className="p-6 bg-white">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold mb-4">Edit Job</h2>
        <img src={edit} alt="edit.svg" className="h-20" />
      </div>
      <form className="space-y-4">
        {/* First two inputs in a flex row */}
        <div className="flex space-x-4">
          <input
            type="text"
            placeholder="Job Title"
            className="rounded-lg w-full p-2 h-12 bg-gray-200 outline-none text-black flex-1"
            value={job.title}
            onChange={(e) =>
              setJob({ ...job, title: e.target.value })
            }
          />
          <input
            type="text"
            placeholder="Company"
            className="rounded-lg w-full p-2 h-12 bg-gray-200 outline-none text-black flex-1"
            value={job.company}
            onChange={(e) =>
              setJob({ ...job, company: e.target.value })
            }
          />
        </div>

        {/* Remaining inputs in a flex column */}
        <div className="space-y-4">
          <input
            type="text"
            placeholder="Location"
            className="rounded-lg w-full p-2 h-12 bg-gray-200 outline-none text-black"
            value={job.location}
            onChange={(e) =>
              setJob({ ...job, location: e.target.value })
            }
          />
          <input
            type="text"
            placeholder="Experience"
            className="rounded-lg w-full p-2 h-12 bg-gray-200 outline-none text-black"
            value={job.experience}
            onChange={(e) =>
              setJob({ ...job, experience: e.target.value })
            }
          />
          <input
            type="text"
            placeholder="Qualifications (comma-separated)"
            className="rounded-lg w-full p-2 h-12 bg-gray-200 outline-none text-black"
            value={job.qualifications.join(",")}
            onChange={(e) =>
              setJob({
                ...job,
                qualifications: e.target.value.split(",").map((q) => q.trim()),
              })
            }
          />
          <textarea
            placeholder="Job Description"
            className="rounded-lg w-full p-2 bg-gray-200 text-black resize-none"
            rows="4"
            value={job.description}
            onChange={(e) =>
              setJob({ ...job, description: e.target.value })
            }
          ></textarea>
        </div>
        <button
          className="w-full py-2 h-20 bg-teal-600 text-white font-semibold rounded hover:bg-teal-700"
          onClick={(e) => {
            e.preventDefault();
            handleUpdateJob(job);
          }}
        >
          Save Changes <i class='bx bx-save' ></i>
        </button>
      </form>
    </div>
  );
}